import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialStoreStoragePageState,
  StoreStorageItemData,
} from "../core/_model.storeStorage";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedStoreStorage = {
  data: StoreStorageItemData | null;
  action: ActionsKey;
};

type StoreStorageDataType = {
  storeStorageList: any;
  detail: StoreStorageItemData | null;
  actioned: ActionedStoreStorage | null;
  totalItems?: number;
  setDetail: (detail: StoreStorageItemData | null) => void;
  setStoreStorageList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedStoreStorage | null) => void;
};

export const useStoreStorageStore = create<StoreStorageDataType>(
  (set) => ({
    storeStorageList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setStoreStorageList: (saleData) =>
      set((state) => ({
        storeStorageList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useStoreStorageListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialStoreStoragePageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
